export default __webpack_public_path__ + "static/media/settings.cc7eb0b6.svg";